<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body" style="padding-bottom: 0px; padding-top: 10px">
            <div class="card-body-form">
              <!-- 内容 -->
              <div>
                <div
                  style="
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                  "
                >
                  <div style="font-weight: bold">置顶内容：</div>
                  <i
                    @click="getData"
                    class="el-icon-refresh"
                    style="
                      font-size: 20px;
                      margin-left: 10px;
                      font-weight: bold;
                      color: #556ee6;
                      cursor: pointer;
                    "
                  ></i>
                </div>
                <div class="item">
                  <t-table
                    rowKey="id"
                    :columns="columns"
                    :data="top_list"
                    dragSort="row-handler"
                    :scroll="{ type: 'lazy', bufferSize: 10 }"
                    @drag-sort="onDragSort"
                    :max-height="640"
                    :loading="topLoading"
                  >
                    <!-- <template #status="{ row, }">
                      <p
                        class="status"
                        :class="['', 'warning', 'unhealth'][row.status]"
                      >
                        {{ ["健康", "警告", "异常"][row.status] }}
                      </p>
                    </template> -->
                    <!-- <template #attachment="{ row }">
                      <div v-if="row.attachmentDtoList[0]">
                        <div v-if="row.attachmentDtoList[0].type == 'image'">
                          <img
                            :src="row.attachmentDtoList[0].url"
                            style="cursor: pointer; height: 50px"
                            @click="showImg(row.attachmentDtoList[0].url)"
                          />
                        </div>
                      </div>
                      <span v-else>--</span>
                    </template> -->
                    <template #message="{ row }">
                      {{ row.message
                      }}<t-icon
                        color="#556ee6"
                        name="attach"
                        v-if="row.attachmentDtoList && row.attachmentDtoList[0]"
                      />
                    </template>
                    <template #showState="{ row }">
                      <el-tooltip
                        :content="row.state == 1 ? '点击隐藏' : '点击显示'"
                      >
                        <span
                          v-if="row.state == 1"
                          class="dsply-fix status-open"
                          @click="changeStatus(row)"
                          ><i></i>显示</span
                        >
                        <span
                          v-if="row.state == 0"
                          class="dsply-fix status-off"
                          @click="changeStatus(row)"
                          ><i></i>隐藏</span
                        >
                      </el-tooltip>
                    </template>
                    <template #verifyState="{ row }">
                      {{ showState(row.verifyState) }}
                    </template>
                    <template #drag="{ row, rowIndex }">
                      <el-button
                        size="mini"
                        type="primary"
                        @click="toDetail(row.id)"
                        >编辑</el-button
                      >
                      <el-button
                        size="mini"
                        type="primary"
                        @click="removeTop(row, rowIndex)"
                        >取消置顶</el-button
                      >
                      <el-button
                        size="mini"
                        type="danger"
                        @click="deleteConfirm(row.id, rowIndex, 1)"
                        >删除</el-button
                      >

                      <i
                        style="font-size: 20px; margin-left: 10px"
                        class="el-icon-rank"
                      ></i>
                    </template>
                  </t-table>
                </div>
              </div>
              <!-- 列表 -->
              <div style="margin-top: 37px">
                <div style="margin-bottom: 13px">
                  <div style="display: flex; justify-content: space-between">
                    <span>内容列表：</span>

                    <span style="display: flex">
                      <span>
                        <b-form-select
                          @change="getContentList"
                          v-model="pageParams.showState"
                          class="form-select"
                          :options="statusOptions"
                          style="width: 100px; height: 32px; margin-right: 15px"
                          type="text"
                        ></b-form-select>
                      </span>
                      <el-input
                        style="width: 225px; margin-right: 20px"
                        v-model="pageParams.content"
                        size="small"
                        placeholder="id、内容"
                        @keyup.enter.native="getContentList"
                      ></el-input>
                      <el-button
                        type="primary"
                        size="mini"
                        @click="getContentList"
                        >搜索</el-button
                      >
                      <el-button size="mini" @click="resetSearch"
                        >重置</el-button
                      >
                    </span>
                  </div>
                </div>
                <div class="item">
                  <t-table
                    rowKey="id"
                    :columns="columnsHT"
                    :data="content_list"
                    :loading="contentLoading"
                  >
                    <template #message="{ row }">
                      {{ row.message
                      }}<t-icon
                        color="#556ee6"
                        name="attach"
                        v-if="row.attachmentDtoList && row.attachmentDtoList[0]"
                      />
                    </template>
                    <!-- <template #status="{ row }">
                      <p
                        class="status"
                        :class="['', 'warning', 'unhealth'][row.status]"
                      >
                        {{ ["健康", "警告", "异常"][row.status] }}
                      </p>
                    </template> -->
                    <template #attachment="{ row }">
                      <div v-if="row.attachmentDtoList[0]">
                        <div v-if="row.attachmentDtoList[0].type == 'image'">
                          <img
                            :src="row.attachmentDtoList[0].url"
                            style="cursor: pointer; height: 50px"
                            @click="showImg(row.attachmentDtoList[0].url)"
                          />
                        </div>
                      </div>
                      <span v-else>--</span>
                    </template>
                    <template #showState="{ row }">
                      <el-tooltip
                        :content="row.state == 1 ? '点击隐藏' : '点击显示'"
                      >
                        <span
                          @click="changeStatus(row)"
                          v-if="row.state == 1"
                          class="dsply-fix status-open"
                          ><i></i>显示</span
                        >
                        <span
                          v-if="row.state == 0"
                          class="dsply-fix status-off"
                          @click="changeStatus(row)"
                          ><i></i>隐藏</span
                        >
                      </el-tooltip>
                    </template>
                    <template #verifyState="{ row }">
                      {{ showState(row.verifyState) }}
                    </template>
                    <template #option="{ row, rowIndex }">
                      <el-button
                        size="mini"
                        type="primary"
                        @click="toDetail(row.id)"
                        >编辑</el-button
                      >
                      <el-button
                        size="mini"
                        type="primary"
                        @click="setTop(row, rowIndex)"
                        >置顶</el-button
                      >
                      <el-button
                        size="mini"
                        type="danger"
                        @click="deleteConfirm(row.id, rowIndex, 2)"
                        >删除</el-button
                      >
                    </template>
                  </t-table>
                  <pagination
                    ref="page"
                    :pageSize="pageParams.pageSize"
                    :page="pageParams.page"
                    :pageSizes="[30, 50, 100]"
                    :total="pageTotal"
                    @pageCallback="pageCallback"
                  ></pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 新建 -->

    <ContentDetail
      :id="contentId"
      v-if="detailModal"
      :visible.sync="detailModal"
      @change="getContentList"
    />
  </div>
</template>

<script>
import ContentDetail from "./contentDetail.vue";
import groupApi from "@/server/api/group.js";
import pagination from "@/components/pagination/pagination.vue";
const cityOptions = ["上海", "北京", "广州", "深圳"];
const columns = [
  { colKey: "id", title: "ID", width: 100 },
  {
    colKey: "userName",
    title: "用户信息",
    width: 120,
  },
  {
    colKey: "message",
    title: "正文",
    width: 200,
  },
  // { colKey: "attachment", title: "附件", width: 100 },
  { colKey: "verifyState", title: "审核状态", width: 120 },
  { colKey: "showState", title: "状态", width: 100 },
  { colKey: "createdAt", title: "发布时间", width: 180 },

  {
    colKey: "drag", // 列拖拽排序必要参数
    title: "操作",
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    // cell: (h) => <i style="font-size:20px;" class="el-icon-rank"></i>,
    width: 300,
    fixed: "right",
  },
];
const columnsHT = [
  { colKey: "id", title: "ID", width: 100 },
  {
    colKey: "userName",
    title: "用户信息",
    width: 120,
  },
  {
    colKey: "message",
    title: "正文",
    width: 200,
  },
  // { colKey: "attachment", title: "附件", width: 100 },
  { colKey: "verifyState", title: "审核状态", width: 120 },
  { colKey: "showState", title: "状态", width: 100 },
  { colKey: "createdAt", title: "发布时间", width: 180 },

  {
    colKey: "option", // 列拖拽排序必要参数
    title: "操作",
    width: 300,
    fixed: "right",
  },
];
const columnsAd = [
  {
    colKey: "row-select",
    type: "multiple",
    className: "demo-multiple-select-cell",
    width: 64,
  },
  { colKey: "instance", title: "id", width: 80 },
  {
    colKey: "status",
    title: "话题名称",
    width: 150,
  },
  {
    colKey: "survivalTime",
    title: "封面",
    width: 127,
  },
  { colKey: "owner", title: "状态", width: 80 },
  { colKey: "createTime", title: "创建时间", width: 100 },
];

export default {
  components: {
    pagination,
    ContentDetail,
  },
  data() {
    return {
      contentId: undefined,
      loading: false,
      total_list: [],
      pageTotal: 5,
      top_list: [],
      top_list_before: [],
      delete_list: [],
      content_list: [],
      detailModal: false,
      columns,
      columnsHT,
      columnsAd,
      pageParams: {
        page: 1,
        pageSize: 30,
        // type: 2, // 0:草稿，1:初遍池，2：文章列表
        showState: "", //0隐藏1显示
        // sortBy: "",
        // order: "",
        content: "",
      },
      search: {
        keyword: "",
      },
      items: [2],
      addDialog: false,
      titleFlag: "",
      tags: [
        { name: "标签一", type: "info" },
        { name: "标签二", type: "info" },
        { name: "标签三", type: "info" },
        { name: "标签四", type: "info" },
        { name: "标签五", type: "info" },
      ],
      cityOptions,
      statusOptions: [
        { text: "筛选状态", value: "" },
        { text: "显示", value: 1 },
        { text: "隐藏", value: 0 },
      ],
      groupId: "",
      topLoading: false,
      contentLoading: false,
    };
  },
  mounted() {
    this.groupId = Number(this.$route.query.id);
    this.getData();
  },
  methods: {
    changeStatus(item) {
      let msg = item.state == 0 ? "确认显示？" : "确认隐藏？";
      this.confirm(msg, () => {
        groupApi.contentStatus(item.id).then((res) => {
          console.log("更改结果", res);
          if (res.code === 0) {
            this.$message.success("更改成功");
            item.state = !item.state;
          } else {
            this.warning(res.msg);
            console.log(res);
          }
        });
      });
    },
    resetSearch() {
      this.pageParams.showState = "";
      this.pageParams.content = "";
      this.pageParams.page = 1;
      this.getContentList();
    },
    showState(state) {
      if (state === 0) {
        return "草稿";
      } else if (state === 1) {
        return "通过";
      } else if (state === 2) {
        return "驳回";
      } else if (state == 3) {
        return "待审核";
      }
    },
    // currentData is going to be deprecated
    onDragSort({
      currentIndex,
      current,
      targetIndex,
      target,
      data,
      newData,
      e,
    }) {
      let oldList = this.another(this.top_list);
      this.top_list = newData;
      let params = newData.map((item, index) => {
        return {
          id: item.id,
          viewOrder: index,
        };
      });
      groupApi.topSort(params).then((res) => {
        if (res.code === 0) {
          this.$message.success("排序成功");
        } else {
          this.top_list = oldList;
          this.warning(res.msg || "排序失败");
        }
      });
    },

    //给组件的回调
    pageCallback(obj) {
      if (obj.code === "pageSize") {
        this.pageParams.pageSize = obj.ps;
        this.getContentList();
      }
      if (obj.code === "page") {
        //更改页码
        this.pageParams.page = obj.page;
        this.getContentList();
      }
      if (obj.code === "batch") {
        //处理批量操作
        console.log(this.choiceListIds, "批量的id");
        if (obj.batch == 1) {
          if (this.choiceListIds.length) {
            //点击显示的处理方法
            this.batchShow();
          } else {
            Vue.swal("请选择要显示的内容");
            return;
          }
        }
        if (obj.batch == 2) {
          if (this.choiceListIds.length) {
            //点击隐藏的处理方法
            this.batchHide();
          } else {
            Vue.swal("请选择要隐藏的内容");
            return;
          }
        }
        if (obj.batch == 3) {
          if (this.choiceListIds.length) {
            //点击撤稿的处理方法
            this.batchRevert();
          } else {
            Vue.swal("请选择要撤稿的内容");
            return;
          }
        }
        if (obj.batch == 4) {
          if (this.choiceListIds.length) {
            //点击修改媒体号的处理方法
            this.$refs.media.showModel(this.choiceListIds, "article");
            this.choiceListIds = [];
          } else {
            Vue.swal("请选择要修改的内容");
            return;
          }
        }
      }
    },
    showImg(url) {
      this.ShowImg(url);
    },
    getData() {
      this.getTopList();
      this.getContentList();
    },
    openDetailModal() {
      this.detailModal = true;
    },
    getTopList(showLoading) {
      if (showLoading !== false) {
        this.top_list = [];
        this.topLoading = true;
      }
      let params = { id: this.groupId };
      console.log("置顶内容搜索参数", params);
      groupApi.topList(params).then((res) => {
        console.log("置顶列表", res);
        if (res.code === 0) {
          this.topLoading = false;
          this.top_list_before = [];
          if (res.data) {
            this.top_list = res.data;
            res.data.forEach((item) => {
              this.top_list_before.push(item.id);
            });
          } else {
            this.top_list = [];
          }
        }
      });
    },
    getContentList(showLoading) {
      if (showLoading !== false) {
        this.content_list = [];
        this.contentLoading = true;
      }
      let params = this.another(this.pageParams);
      params.id = this.groupId;
      groupApi.contentList(params).then((res) => {
        console.log("内容列表", res);
        if (res.code === 0) {
          this.contentLoading = false;
          this.content_list = res.data.items;
          this.pageTotal = res.data.total;
        }
      });
    },
    toDetail(id) {
      this.contentId = id;
      this.detailModal = true;
    },
    goBack() {
      this.$router.go(-1);
    },
    setTop(item, index) {
      let arr = this.another(this.top_list);
      arr.unshift(item);
      //置顶参数
      let params = [item.id];
      groupApi.addTop(params).then((res) => {
        if (res.code === 0) {
          let params2 = arr.map((tr, i) => {
            return {
              id: tr.id,
              viewOrder: i, //已经有0了，需要从1开始
            };
          });
          groupApi.topSort(params2).then((res) => {
            console.log("排序结果", res);
            this.top_list = arr;
            this.getTopList(false);
            this.pageTotal -= 1;
            this.content_list.splice(index, 1);
            this.$message.success("置顶成功");
          });
        } else {
          this.warning(res.msg || "置顶失败");
        }
      });
    },
    //取消置顶
    removeTop(item, index) {
      groupApi.removeTop([item.id]).then((res) => {
        if (res.code === 0) {
          this.top_list.splice(index, 1);
          this.content_list.unshift(item);
          this.pageTotal += 1;
          this.getContentList(false);
          this.$message.success("操作成功");
        } else {
          this.warning(res.msg || "操作失败");
        }
      });
    },
    deleteContent(id, index, position) {
      let arr = [];
      arr.push(id);
      let params = { ids: arr };
      groupApi.commentDelete(params).then((res) => {
        console.log("删除结果", res);
        if (res.code === 0) {
          this.$message.success("删除成功");
          if (position == 1) {
            this.top_list.splice(index, 1);
          } else {
            this.content_list.splice(index, 1);
            this.pageTotal -= 1;
          }
        } else {
          this.warning(res.msg);
          console.log(res);
        }
      });
    },
    deleteConfirm(id, index, position) {
      this.confirm("确认删除该条内容？", () => {
        this.deleteContent(id, index, position);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.tagWrap {
  .el-tag + .el-tag {
    margin-left: 10px;
  }
}

.tagWarp {
  margin-bottom: 13px;
  display: flex;
  .searTag {
    height: 350px;
    width: 70%;
  }
  .checkTag {
    height: 350px;
    width: 30%;
  }
}
.checkWarp {
  background: #ffffff;
  border: 1px solid #e2e2e2;
  border-radius: 3px;
  padding: 10px;
  height: 100%;
}
</style>
